import { useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';

export const Miniwidget = (): JSX.Element => {
  const { estate: data } = useContext(ObjectPageContext);

  return (
    <div
      className={`${
        data?.econansReady ? 'lg:px-4 xxl:px-10 my-6 lg:my-16' : ''
      }`}
    >
      <div
        className={`${
          data?.econansReady
            ? 'bg-white shadow-bs40 rounded-md overflow-hidden'
            : ''
        } `}
      >
        <div className="overflow-hidden" id="miniwidget"></div>
      </div>
    </div>
  );
};
export default Miniwidget;
